export var DEPARTMENTS = function(strictLocalize) {
    return {
        Accounting: {
            title: strictLocalize({
                id: "2hjd3f",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Accounting"
                    }
                ]
            })
        },
        "Algorithms & Data": {
            title: strictLocalize({
                id: "DeeoNi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Algorithms & Data"
                    }
                ]
            })
        },
        "Business Operations": {
            title: strictLocalize({
                id: "YWO6K5",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Business Operations"
                    }
                ]
            })
        },
        Corporate: {
            title: strictLocalize({
                id: "zdW4x1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Corporate"
                    }
                ]
            })
        },
        "Customer Support": {
            title: strictLocalize({
                id: "c6qmE7",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Customer Support"
                    }
                ]
            })
        },
        "Customer Success": {
            title: strictLocalize({
                id: "1R11PT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Customer Success"
                    }
                ]
            }),
            parentDepartment: "Customer Support"
        },
        "Customer Support Management": {
            title: strictLocalize({
                id: "eCV46p",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Customer Support Management"
                    }
                ]
            }),
            parentDepartment: "Customer Support"
        },
        Design: {
            title: strictLocalize({
                id: "Nnxlfl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Design"
                    }
                ]
            })
        },
        Engineering: {
            title: strictLocalize({
                id: "55aISG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Engineering"
                    }
                ]
            })
        },
        Finance: {
            title: strictLocalize({
                id: "fX3Wn1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Finance"
                    }
                ]
            })
        },
        Legal: {
            title: strictLocalize({
                id: "Ye7ecI",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Legal"
                    }
                ]
            })
        },
        Marketing: {
            title: strictLocalize({
                id: "MBpcNW",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Marketing"
                    }
                ]
            })
        },
        "Marketplace Operations": {
            title: strictLocalize({
                id: "f79yxA",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Marketplace Operations"
                    }
                ]
            })
        },
        People: {
            title: strictLocalize({
                id: "N2HDCZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "People"
                    }
                ]
            })
        },
        Product: {
            title: strictLocalize({
                id: "VkB9ul",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Product"
                    }
                ]
            })
        },
        "Retail and Brand": {
            title: strictLocalize({
                id: "asLTEv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Retail and Brand"
                    }
                ]
            })
        },
        Risk: {
            title: strictLocalize({
                id: "NlXAbV",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Risk"
                    }
                ]
            })
        },
        Sales: {
            title: strictLocalize({
                id: "/IZRh7",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sales"
                    }
                ]
            })
        },
        "Brand Partnerships": {
            title: strictLocalize({
                id: "0t/Fww",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Brand Partnerships"
                    }
                ]
            }),
            parentDepartment: "Sales"
        },
        "Retail Sales": {
            title: strictLocalize({
                id: "BZMEwo",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Retail Sales"
                    }
                ]
            }),
            parentDepartment: "Sales"
        },
        "Retail Account Management": {
            title: strictLocalize({
                id: "eT7nK+",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Retail Account Management"
                    }
                ]
            }),
            parentDepartment: "Sales"
        },
        "Brand Success Management": {
            title: strictLocalize({
                id: "VrrXEz",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Brand Success Management"
                    }
                ]
            }),
            parentDepartment: "Sales"
        },
        "Sales Management": {
            title: strictLocalize({
                id: "8eJarf",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sales Management"
                    }
                ]
            }),
            parentDepartment: "Sales"
        },
        "Strategy & Analytics ": {
            title: strictLocalize({
                id: "acbCrR",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Strategy & Analytics"
                    }
                ]
            })
        },
        Talent: {
            title: strictLocalize({
                id: "7Q7eKK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Talent"
                    }
                ]
            })
        }
    };
};
